import apiClient from "./apiClient";

export * from "./apiClient";
export * from "./rooms";

export function fetchInstructorCourses(instructorId) {
  return apiClient
    .get(`/api/v1/instructors/${instructorId}/courses`)
    .then((response) => response.data);
}

export function fetchInstructorStats(instructorId) {
  return apiClient
    .get(`/api/v1/instructors/${instructorId}/stats`)
    .then((response) => response.data);
}

export function fetchCoordinatorStats(tenantId) {
  return apiClient
    .get(`/api/v1/instructors/stats`, { params: { role: "COORDINATOR" }, headers: tenantId ? { "X-Tenant-Id": tenantId } : {} })
    .then((response) => response.data);
}

export function fetchInstructorPendingSignOffs(instructorId) {
  return apiClient
    .get(`/api/v1/instructors/${instructorId}/pending-signoffs`)
    .then((response) => response.data);
}

export function fetchStudentCourseProgress(courseId, studentId) {
  return apiClient
    .get(`/api/v1/courses/${courseId}/students/${studentId}/progress`)
    .then((response) => response.data);
}

export function fetchStudentAttendance(courseId, studentId) {
  return apiClient
    .get(`/api/v1/courses/${courseId}/students/${studentId}/attendance`)
    .then((response) => response.data);
}

export function fetchChecklistEvaluation(courseId, checklistId, studentId) {
  return apiClient
    .get(
      `/api/v1/courses/${courseId}/checklists/${checklistId}/evaluations/${studentId}`,
    )
    .then((response) => response.data);
}

export function saveEvaluationDraft(courseId, checklistId, studentId, data) {
  return apiClient
    .put(
      `/api/v1/courses/${courseId}/checklists/${checklistId}/evaluations/${studentId}/draft`,
      data,
    )
    .then((response) => response.data);
}

export function submitInstructorSignOff(courseId, checklistId, studentId, data) {
  return apiClient
    .post(
      `/api/v1/courses/${courseId}/checklists/${checklistId}/evaluations/${studentId}/signoff`,
      data,
    )
    .then((response) => response.data);
}

/** Start a new attempt after a FAIL sign-off (instructor of the class, coordinator or admin). */
export function reEvaluateChecklist(courseId, checklistId, studentId) {
  return apiClient
    .post(
      `/api/v1/courses/${courseId}/checklists/${checklistId}/evaluations/${studentId}/re-evaluate`,
    )
    .then((response) => response.data);
}

/** Attempt history, oldest first; the last entry is the current attempt (current: true). */
export function fetchEvaluationAttempts(courseId, checklistId, studentId) {
  return apiClient
    .get(
      `/api/v1/courses/${courseId}/checklists/${checklistId}/evaluations/${studentId}/attempts`,
    )
    .then((response) => response.data);
}
